// 2 for 1 Pollo Wednesday — Van Nuys only.
//
// Buy two 1/4 pollo a la brasa plates (each with fresh cut fries & house
// salad) for the price of one. The promo category is built client-side from
// the shop's own "1/4 Chicken (2 sides)" product and prepended to the menu in
// src/Context/applyDiscount.js, so nothing has to change in the POS menu.
// Flip `polloWednesdayEnabled` to false to retire it everywhere — banners,
// modal and menu category all key off it.

import {isLAWednesday} from './wingWednesday'

export const polloWednesdayEnabled = true

export const polloWednesdayShopIds = [
  'pablitostacosvannuys',
]

// Two plates' worth of the standard 3 free sauces.
export const FREE_SAUCE_COUNT = 6

export function isPolloWednesday() {
  return polloWednesdayEnabled && isLAWednesday()
}

export function isPolloWednesdayShop(shopId) {
  return polloWednesdayShopIds.indexOf(shopId) !== -1
}

export function isPolloWednesdayLive(shopId) {
  return isPolloWednesdayShop(shopId) && isPolloWednesday()
}

// Matches the shop's own quarter-chicken plate. Name-matched rather than
// id-matched so a re-created POS product doesn't silently kill the promo.
function findQuarterChicken(menu) {
  const subMenus = (menu && menu.subMenus) || []
  for (let subMenu of subMenus) {
    for (let product of (subMenu.products || [])) {
      const name = ((product.name && product.name.en) || '').toLowerCase()
      if (name.indexOf('1/4') === -1) { continue }
      if (name.indexOf('chicken') === -1 && name.indexOf('pollo') === -1) { continue }
      if (!Number(product.price)) { continue }
      return product
    }
  }
  return null
}

// Sides are fixed to fries + salad, so the side pickers are dropped. The free
// sauce picker is kept so the kitchen still gets the customer's sauce choices,
// with double the usual allowance since the deal is two plates.
function promoModgroups(product) {
  return (product.modgroups || []).filter((modgroup) => {
    const name = (modgroup.name || '').toLowerCase()
    if (name.indexOf('side') !== -1) { return false }
    if (name.indexOf('extra sauce') !== -1) { return false }
    return true
  }).map((modgroup) => {
    const name = (modgroup.name || '').toLowerCase()
    if (name.indexOf('free sauce') === -1) { return modgroup }
    return Object.assign({}, modgroup, {maxCount: FREE_SAUCE_COUNT})
  })
}

// Builds the promo category from the shop's live menu. Returns null when the
// shop has no quarter chicken on the menu, so we never show an empty promo.
export function buildPolloWednesdayCategory(menu) {
  const source = findQuarterChicken(menu)
  if (!source) { return null }

  const singlePrice = Number(source.price)

  const product = Object.assign({}, source, {
    id: 'pollo-wednesday-2-for-1',
    name: {en: '2 for 1 — Two 1/4 Pollo a la Brasa Plates'},
    description: {en: 'Two 1/4 pollo a la brasa plates, each with fresh cut fries & house salad. Pay for one — Wednesdays only.'},
    originalPrice: Math.round(singlePrice * 2 * 100) / 100,
    price: singlePrice,
    tags: 'pollo-wednesday-item',
    modgroups: promoModgroups(source),
  })

  return {
    id: 'pollo-wednesday',
    // real categories all carry shopId — AutoMenu drops categories without one
    // when it is handed a shopId prop
    shopId: menu && menu.shopId,
    name: {en: '🍗 POLLO WEDNESDAY — 2 for 1 Pollo a la Brasa'},
    description: {en: 'Two 1/4 pollo a la brasa plates with fresh cut fries & house salad for the price of one. Today only.'},
    // pab-chicken / pab-tacos keep the promo visible on both the /vannuys and
    // /vannuyschicken menus, which filter categories by concept tag
    tag: 'pollo-wednesday-promo, pab-chicken, pab-tacos',
    products: [product],
  }
}
